module.exports = __webpack_public_path__ + "static/media/sidebar-1.6be21e8a.jpg";